<template>
  <div class="neo-app__container">
    <div class="neo-app">
      <div class="neo-app__header">
        <div v-if="tab === 'home'" class="neo-app__header-text">
          <span></span>
          <p>Hello <span class="text-bold">Jane!</span></p>
        </div>
        <div v-else class="neo-app__header-text">
          <p>
            <span class="text-bold">{{ formatText(tab) }}</span>
          </p>
        </div>
        <div class="neo-app__header-logout" @click="logout">
          <span>
            <img :src="getAppImage('logout.svg')" alt="" />
          </span>
        </div>
      </div>
      <div class="neo-app__body">
        <slot />
      </div>
      <div class="neo-app__nav">
        <div
          v-for="(route, i) in routes"
          :key="i"
          :class="['neo-app__nav-link', { active: tab === route.route }]"
          @click="routeTo(route.route)"
        >
          <img :src="getAppImage(`${route.icon}.svg`, 'app')" alt="" />
          <span>{{ route.name }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppLayout",
  data() {
    return {
      tab: "home",
      routes: [
        {
          name: "Home",
          icon: "home",
          route: "home",
        },
        {
          name: "Transactions",
          icon: "transactions",
          route: "transactions",
        },
        {
          name: "Settings",
          icon: "settings",
          route: "settings",
        },
      ],
    };
  },
  mounted() {
    const { name } = this.$route;
    if (name) {
      this.tab = name.split(".")[0];
    }
  },
  methods: {
    routeTo(route) {
      this.tab = route;
      this.$router.push({ name: `${route}.index` });
    },
    logout() {
      this.$router.push({ name: "website" });
      this.notification({
        type: "success",
        message: "You are logged out!",
      });
    },
  },
};
</script>

<style lang="scss">
.neo-app__container {
  background: #f8faf9;
  display: flex;
  justify-content: center;
  align-items: center;
}

.neo-app {
  overflow-y: hidden;
  height: 100vh;
  width: 100%;
  padding: 80px 0;
  background: #ffffff;
  position: relative;

  &__header {
    position: absolute;
    top: 0;
    left: 0;
    height: 70px;
    width: 100%;
    padding: 0 25px;
    background: #ffffff;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.05);
    display: flex;
    justify-content: space-between;
    align-items: center;

    &-text {
      display: flex;
      align-items: center;

      > span {
        height: 32px;
        width: 32px;
        background: #121212;
        border-radius: 100px;
        margin-right: 10px;
      }

      p {
        opacity: 1;
        font-size: 1.125rem;

        span {
          font-weight: bold;
        }
      }
    }

    &-logout {
      cursor: pointer;
      span {
        height: 36px;
        width: 36px;
        border-radius: 100px;
        background: #00000010;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  &__body {
    height: 100%;
    padding: 20px;
    overflow-y: scroll;
  }

  &__nav {
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 9;
    height: 70px;
    width: 100%;
    padding: 0 25px;
    background: #ffffff;
    box-shadow: 5px 0 10px rgba(0, 0, 0, 0.05);
    border-radius: 20px 20px 0 0;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &-link {
      display: flex;
      align-items: center;
      opacity: 0.4;
      cursor: pointer;
      transition: opacity 0.3s ease-out;

      img {
        margin-right: 10px;
      }

      span {
        font-size: 0.875rem;
      }

      &.active {
        opacity: 1;
        transition: opacity 0.3s ease-in;
      }
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

@media (min-width: 768px) {
  .neo-app__container {
    height: 100vh;
    padding: 20px;
  }

  .neo-app {
    height: calc(100vh - 40px);
    box-shadow: -8px 32px 50px rgba(0, 0, 0, 0.06);
    position: relative;
    width: 420px;

    &__nav {
      padding: 0 35px !important;
    }
  }
}
</style>
